/**
 * useMaterialsStats — статистика вкладки «Материалы» (ЮНИГАЗЕТА) для DC → Юнифанс.
 * Источник: GET /api/commerce/materials-stats?from=&to= (агрегат client_events).
 */
import { useEffect, useState } from "react";
import { api } from "../api/client";

export interface MatSummary {
  opens: number; readers: number; taps: number; users: number;
  opensPerReader: number; tapsPerReader: number;
}
export interface MatDay { d: string; opens: number; readers: number; taps: number }
export interface MatRubric { plays: number; viewers: number; watchMin: number; completionRate: number }
export interface MatAction { kind: string; n: number; users: number }
export interface MatElement { label: string; n: number; users: number }
export interface MatReader {
  tg: number; name: string; username: string; avatarUrl: string;
  opens: number; events: number; lastSeen: string;
}
export interface MaterialsStats {
  summary: MatSummary;
  daily: MatDay[];
  rubrics: { interview: MatRubric; yuskar: MatRubric; guest: MatRubric };
  actions: MatAction[];
  elements: MatElement[];
  topReaders: MatReader[];
  generatedAt: string;
}

export interface UseMaterialsStatsResult {
  data: MaterialsStats | null;
  loading: boolean;
  error: string | null;
  reload: () => void;
}

export function useMaterialsStats(from?: string, to?: string): UseMaterialsStatsResult {
  const [data, setData] = useState<MaterialsStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [trigger, setTrigger] = useState(0);

  useEffect(() => {
    let live = true;
    setLoading(true);
    setError(null);
    const qs = new URLSearchParams();
    if (from) qs.set("from", from);
    if (to) qs.set("to", to);
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    api<MaterialsStats>(`/api/commerce/materials-stats${suffix}`)
      .then((d) => { if (live) setData(d); })
      .catch((e) => { if (live) setError(e instanceof Error ? e.message : "Ошибка загрузки"); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [from, to, trigger]);

  return { data, loading, error, reload: () => setTrigger((n) => n + 1) };
}

/** Человеческие названия событий газеты для UI. */
export const MAT_ACTION_LABELS: Record<string, string> = {
  vestnik_horoscope_tap: "Гороскоп — открыл знак",
  vestnik_horoscope_reward_tap: "Гороскоп — тап по награде",
  vestnik_horoscope_reward_claim: "Гороскоп — забрал юникоины",
  vestnik_censor_tap: "Цензурный блок",
  vestnik_yuskar_vote: "ЮСКАР — голос засчитан",
  vestnik_yuskar_vote_tap: "ЮСКАР — тап по кандидату",
  vestnik_yuskar_submission_open: "ЮСКАР — открыл отправку своего видео",
  vestnik_yuskar_submission_sent: "ЮСКАР — отправил своё видео",
  vestnik_player_tiktok_click: "Гости — переход в TikTok",
  vestnik_interview_open: "Интервью — открыл",
};
